import { RouteComponentProvider } from '@micro-frontend-react/employee-experience/lib/RouteComponentProvider';
import { useLoginOnStartup } from '@micro-frontend-react/employee-experience/lib/useLoginOnStartup';
import * as React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { NotAllowed } from './NotAllowed';
import { CoherenceThemeProvider } from './Shared/Components/CoherenceThemeProvider';
import { Footer } from './Shared/Components/Footer';
import { FooterWrapper } from './Shared/Components/Footer/FooterWrapper';
import { Header } from './Shared/Components/Header';
import { Main } from './Shared/Components/Main/Main.styled';
import { useHeaderConfig } from './Shared/Hooks/useHeaderConfig';
import { useIsGuest } from './Shared/Hooks/useIsGuest';
import { useOCV } from './Shared/Hooks/useOCV';
import { ShellWithStore } from './ShellWithStore';

function App(): React.ReactElement {
  // useOCV(); // TODO: uncomment to re-add OCV
  const headerConfig = useHeaderConfig();

  let isGuest = useIsGuest();

  useLoginOnStartup(!isGuest, {
    scopes: [__API_RESOURCE__],
  });

  return (
    <CoherenceThemeProvider>
      <BrowserRouter>
        <Header {...headerConfig} />
        <Main id='main' tabIndex={0}>
          <Switch>
            {__IS_DEVELOPMENT__ && (
              <RouteComponentProvider
                path="/playground"
                config={{
                  script: 'http://localhost:9000/bundles/playground.js',
                  name: 'Playground',
                }}
                exact
              />
            )}

            <RouteComponentProvider
              path="/"
              config={{
                script: `${__BASE_URL__}/bundles/dashboard.js`,
                name: 'Dashboard',
              }}
              exact
            />

            <Route path="/not-allowed" component={NotAllowed} />
          </Switch>
        </Main>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </BrowserRouter>
    </CoherenceThemeProvider>
  );
}

render(
  <ShellWithStore>
    <App />
  </ShellWithStore>,
  document.getElementById('app')
);
